// Process-specific sync wire schemas.
// The doc schema is derived from the Drizzle table via `wireFromDrizzle`.
// Envelope schemas (pull/push in+out) are built from the generic factories
// in `schemas.ts`.

import { processes } from '../../../drizzle/v2Schema';
import { wireFromDrizzle } from './lib/wireFromDrizzle';
import { processItemSummaryDocSchema } from './processItemSummaries';
import {
  checkpointSchema,
  makePullInput,
  makePushInput,
  makePushOutput,
  syncEntityIdSchema,
  syncTitleSchema,
  syncUserIdSchema,
} from './schemas';
import { z } from 'zod/v4';

// ─── Doc schema ─────────────────────────────────────────────

export const processDocSchema = wireFromDrizzle(processes, {
  overrides: {
    id: () => syncEntityIdSchema,
    title: () => syncTitleSchema,
    userId: () => syncUserIdSchema,
    workspaceId: () => syncEntityIdSchema,
  },
  softDelete: 'deletedAt',
});

export type ProcessDocWire = z.infer<typeof processDocSchema>;

// ─── Envelopes ───────────────────────────────────────────────

export const processesPullInput = makePullInput();
export const processesPullOutput = z.object({
  checkpoint: checkpointSchema.nullable(),
  documents: z.array(processDocSchema),
  summaries: z.array(processItemSummaryDocSchema),
});
export const processesPushInput = makePushInput(processDocSchema);
export const processesPushOutput = makePushOutput(processDocSchema);

export type ProcessesPullInput = z.infer<typeof processesPullInput>;
export type ProcessesPullOutput = z.infer<typeof processesPullOutput>;
export type ProcessesPushInput = z.infer<typeof processesPushInput>;
export type ProcessesPushOutput = z.infer<typeof processesPushOutput>;
export type ProcessesPushRow = z.infer<
  typeof processesPushInput
>['rows'][number];
